import React, { ReactNode } from 'react';
import styled from 'styled-components';

import SpinningRoundedBorder from '#/components/basic/animations/SpinningRoundedBorder';

const Wrap = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

type ButtonProps = {
  children: ReactNode;
  processing?: boolean;
};

/** Loading component to be used in Button or similar actions */
function LoadingText({ children, processing = false }: ButtonProps) {
  return (
    <Wrap>
      {children}
      {processing && (
        <>
          &nbsp;&nbsp;
          <SpinningRoundedBorder inline size={16} />
        </>
      )}
    </Wrap>
  );
}

export default LoadingText;
